import axios, { AxiosResponse } from "axios";
import { SupplierProduct } from "../types";
import { API_URL, getBaseConfig, handleError } from "./apiConfig";

const getApiConfig = () => ({ ...getBaseConfig(), baseURL: API_URL });



/**
 * Get all products from .NET API
 */
export async function getProducts(): Promise<SupplierProduct[] | void> {
    const config = getApiConfig();

    return axios
        .post("Product/GetAll", {}, config)
        .then((response: AxiosResponse<SupplierProduct[]>) => {
            if (response.status === 200) {
                return response.data;
            }
        })
        .catch(handleError);
}

/**
 * Get products for a specific supplier
 */
export async function getProductsBySupplier(supplierId: number): Promise<SupplierProduct[] | void> {
    const config = getApiConfig();

    return axios
        .post("Product/GetBySupplierId", supplierId, config)
        .then((response: AxiosResponse<SupplierProduct[]>) => {
            if (response.status === 200 && response.data) {
                return response.data;
            }
            return [];
        })
        .catch(handleError);
}
